import { ModalLoaderPayload } from './modal-loader-payload.abstract';
import { Component } from '@angular/core';
import { BasicModalLoaderPayload } from './basic-modal-loader-payload';

/**
 * Created by 310293471 on 19/03/2018.
 */
export class PlaceholderModalLoaderPayload<Payload= any> extends BasicModalLoaderPayload {
  public componentToLoad: Component;
  public approveBtn?: string;
  public declineBtn?: string;
  public buttons?: { approveBtn?: string, declineBtn?: string, actionBtn?: string } = { };
  public approveCallback?: (...args) => void;
  public payload?: Payload;
  public disabledFields?: Array<string>;
  private editMode?: boolean = true;

  constructor(
    title: string,
    componentToLoad: any,
    approveBtnText?: string,
    declineBtnText?: string,
    payload?: any,
    /**@deprecated*/approveCallback?: (...args) => void,
    content?: string,
    actionBtnText?: string,
    editMode? : boolean
  ) {
    super(title, content);
    this.componentToLoad = componentToLoad;
    this.buttons.approveBtn = approveBtnText;
    this.buttons.declineBtn = declineBtnText;
    this.buttons.actionBtn = actionBtnText;
    this.approveCallback = approveCallback;
    this.editMode = editMode
    this.payload = payload;
  }

  static builder<Payload_ = any>() {
    return new this<Payload_>(null, null);
  }

  setComponentToLoad(componentToLoad) {
    this.componentToLoad = componentToLoad;
    return this;
  }

  setApproveButton(approveBtn: string) {
    this.buttons.approveBtn = approveBtn;
    return this;
  }

  setDeclineButton(declineBtn: string) {
    this.buttons.declineBtn = declineBtn;
    return this;
  }

  setActionButton(actionBtn: string) {
    this.buttons.actionBtn = actionBtn;
    return this;
  }

  setApproveCallback(approveCallback: (...args) => void) {
    this.approveCallback = approveCallback;
    return this;
  }

  setPayload(payload: Payload) {
    this.payload = payload;
    return this;
  }

  setEditMode(value: boolean) {
    this.editMode = value;
    return this;
  }
}
